import React, { ReactNode, useEffect, useRef } from 'react';
import ExpandCollapsePresenter from './ExpandCollapsePresenter';
import DefaultPresenter from './DefaultPresenter';
import OpacityPresenter from './OpacityPresenter';

type PresenterType = 'ExpandCollapse' | 'Default' | 'Opacity';
type PresentProps = { when: boolean; presenter?: PresenterType; fallback?: ReactNode; className?: string } & React.PropsWithChildren;

export type Presenter = { open: () => void; close: () => void };

export default function Present({ when, children, presenter = 'Default', fallback, className }: PresentProps) {
    const presenterRef = useRef<Presenter>(null);
    const Presenter = getPresenter(presenter);
    useEffect(() => {
        const presenter = presenterRef.current;
        if (presenter) {
            if (when) {
                presenter.open();
            } else {
                presenter.close();
            }
        }
    }, [when]);
    return (
        <Presenter ref={presenterRef} fallback={fallback} className={className}>
            {children}
        </Presenter>
    );
}

function getPresenter(type: PresenterType) {
    switch (type) {
        case 'Default':
            return DefaultPresenter;
        case 'ExpandCollapse':
            return ExpandCollapsePresenter;
        case 'Opacity':
            return OpacityPresenter;
        default:
            return undefined as never;
    }
}
